


























































































import { Vue, Component, Watch } from "vue-property-decorator";
import productHome from "../modules/productHome.vue";
import accountStatus from "../modules/trainAccountStatus.vue";
import { Calendar, Field, Tag, ActionSheet, NoticeBar } from "vant";
import dataShare from "../dataShare";
import * as _ from "lodash";
import moment from "moment";
import { YesOrNo } from "@/model/Base";
import huilianyiService from "@/service/huilianyiService";
@Component({
  components: {
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Calendar.name]: Calendar,
    [ActionSheet.name]: ActionSheet,
    [NoticeBar.name]: NoticeBar,
    "product-home": productHome,
    "account-status": accountStatus,
  },
})
export default class Train extends Vue {
  accountModel = {
    OuterUserAct: "",
  };
  notifyText =
    "自2021年10月1日起，在力程商旅预订火车票将需要关联12306账号，未完成关联的预订人将无法使用铁路官方网站的相关服务（出票、改签、退票等），为避免您的出行受到影响，请务必在此日期前完成相关操作。";
  //data
  dataShare = dataShare;
  datePickerVisible = false;
  isShowNotify = false;
  query = {
    pageIndex: 1,
    DepartDate: (this as any).$moment().format("YYYY-MM-DD"),
    DepartCity: "SHH",
    DepartCityName: this.$root.$t("mall_train_train_shanghai") as string,
    ArriveCity: "BJP",
    ArriveCityName: this.$root.$t("mall_train_train_beijing") as string,
    BookingType: 1529,
    ServiceType: "TrainService",
    ApplyArea: 1126,
    FeatureCodes: "",
    Consumers: "",
  };
  changeCityFlag = false;

  get trainCycle() {
    return moment()
      .add(14, "d")
      .toDate();
  }

  get isSearch() {
    let startTime = moment()
      .hours(5)
      .minutes(30)
      .seconds(0)
      .format("YYYY-MM-DD HH:mm:ss");
    let endTime = moment()
      .hours(24)
      .minutes(30)
      .seconds(0)
      .format("YYYY-MM-DD HH:mm:ss");
    var hours = moment().get("hours");
    var day = new Date().getDay();
    if (hours == 0 && day != 2) {
      startTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
      endTime = moment()
        .hours(0)
        .minutes(30)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
    }

    if (day == 2) {
      endTime = moment()
        .hours(23)
        .minutes(0)
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");
    }

    if (moment(moment().format("YYYY-MM-DD HH:mm:ss")).isBetween(startTime, endTime, null, "[]")) {
      return true;
    } else {
      return false;
    }
  }

  get City() {
    return this.dataShare.City;
  }
  set City(value: any) {
    this.dataShare.City = value;
  }
  get FlowID() {
    return this.$route.query.FlowID;
  }
  get DepartCity() {
    return this.$route.query.DepartCity;
  }
  get ArriveCity() {
  return this.$route.query.ArriveCity;
  }
  get FeatureCodes() {
    if (this.$route.query.FeatureCodes) {
      return this.$route.query.FeatureCodes;
    }
    return "";
  }
   get SelectConsumers() {
    if (this.$route.query.Consumers) {
      return JSON.parse(this.$route.query.Consumers as string);
    }
  }
  get ReturnDate() {
    return this.$route.query.ReturnDate;
  }
  get AdultCount() {
    return this.$route.query.AdultCount;
  } 

  mounted() {
    let __self = this;
    if (__self.FlowID) {
      const queryData = this.$route.query as any;
      __self.query.ApplyArea = queryData.ApplyArea;
      __self.query.BookingType = Number(queryData.BookingType);
      if (queryData.DepartCity != "" && queryData.DepartCity != undefined) {
        __self.query.DepartCity = queryData.DepartCity;
        __self.query.DepartCityName = queryData.DepartCityName;
      }
      if (queryData.ArriveCity != "" && queryData.ArriveCity != undefined) {
        __self.query.ArriveCity = queryData.ArriveCity;
        __self.query.ArriveCityName = queryData.ArriveCityName;
      }
      if (queryData.DepartDate || queryData.DepartDate != "") {
        __self.query.DepartDate = queryData.DepartDate;
      }
    }
    this.City = null;
    this.dataShare.consumers = [];
  }

  //activated
  activated() {
    // this.Consumers = dataShare.consumers;
    if (this.selectCode && this.City && this.City.value) {
      let City = this.City;
      if (this.selectCode == "DepartCity") {
        // this.departCity = this.City;
        this.query.DepartCityName = City.label;
        this.query.DepartCity = City.value;
      } else if (this.selectCode == "ArriveCity") {
        // this.arriveCity = this.City;
        this.query.ArriveCityName = City.label;
        this.query.ArriveCity = City.value;
      }
    }
    this.searchapproval()
  }

  //methods
  formatDate(value: Date, format: string = this.$root.$t("mall_train_train_yueri") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }

  handleSelect(time: Date) {
    this.datePickerVisible = false;
    this.query.DepartDate = time;
  }

  Consumers = [];
  //选择乘客
  gotoAddPassengers() {
    dataShare.consumers = this.Consumers;
    this.$router.push("addPassengers?max=5");
  }
  //取消选择旅客
  closeBar(consumer: object) {
    this.Consumers = _.difference(this.Consumers, [consumer]) as any;
  }
  OneSelf = null;
  showConsumers() {
    let Flag = true;
      if (this.SelectConsumers && this.SelectConsumers.length > 0) {
        return (Flag = false);
      } else  {
        if(this.OneSelf == YesOrNo.Yes){
          let consumers: any = [
          {
            RoleID: this.profile.UserID,
            RoleName: this.profile.UserName,
          },
          ];
          dataShare.consumers = consumers;
          return (Flag = false);
        }
      }
      return Flag;
  }
  OneSelfs(value: any) {
    this.OneSelf = value;
  }
  @Watch("dataShare.consumers")
  handelConsumers(value: any) {
    this.Consumers = dataShare.consumers;
  }

  selectCode = "";
  selectCity(cityType: string) {
    this.City = null;
    this.selectCode = cityType;
    this.$router.push({
      path: "/selectCity",
      query: {
        ServiceType: this.query.ServiceType,
        ApplyArea: this.query.ApplyArea + "",
      },
    });
  }

  changeCity() {
    this.changeCityFlag = !this.changeCityFlag;
    const newArriveCity = this.query.ArriveCity;
    const newArriveCityName = this.query.ArriveCityName;
    this.query.ArriveCity = this.query.DepartCity;
    this.query.ArriveCityName = this.query.DepartCityName;
    this.query.DepartCity = newArriveCity;
    this.query.DepartCityName = newArriveCityName;
  }

  search() {
    if (this.SelectConsumers && this.SelectConsumers.length > 0) {
       this.Consumers = this.SelectConsumers;
    }
    if(this.FeatureCodes){
        this.query.FeatureCodes = this.FeatureCodes as string;
    }
    this.query.Consumers = JSON.stringify(
      this.Consumers.map((item: any) => ({ ConsumerID: item.RoleID, ConsumerName: item.RoleName, SuperiorName: item.SuperiorName, SuperiorType: item.SuperiorType }))
    );
    this.query.DepartDate = this.formatDate(this.query.DepartDate, "YYYY-MM-DD");
    if (this.Consumers.length == 0) {
      return this.$root.$toast.fail(this.$root.$t("mall_train_train_qingxuanzelvke") as string);
    }
    this.$router.push({ path: "train/list", query: this.query as any });
  }
  checkAuditTime(beginTime: any, endTime: any) {
    var nowDate = new Date();
    var beginDate = new Date(nowDate);
    var endDate = new Date(nowDate);

    var beginIndex = beginTime.lastIndexOf("\:");
    var beginHour = beginTime.substring(0, beginIndex);
    var beginMinue = beginTime.substring(beginIndex + 1, beginTime.length);
    beginDate.setHours(beginHour, beginMinue, 0, 0);

    var endIndex = endTime.lastIndexOf("\:");
    var endHour = endTime.substring(0, endIndex);
    var endMinue = endTime.substring(endIndex + 1, endTime.length);
    endDate.setHours(endHour, endMinue, 0, 0);
    return nowDate.getTime() - beginDate.getTime() >= 0 && nowDate.getTime() <= endDate.getTime();
  }
  approvalList:any = [];
  searchapproval() {
     let __self = this;
     huilianyiService.searchapprovals().then((res:any) => {
       __self.approvalList = res.result;
     });
  }
  booking(data:any) {
     let __self = this;
     const id = data.companyId + data.approvalCode;
     huilianyiService.booking(id).then((res:any) => {
       if (res.isSucc) {
        const url = res.result.booking_url; 
        if(this.parseUrlParams(url).productType!=='Train') return this.$root.$toast.fail('业务类型不符，无法预订！');
        location.href = __self.getBookingUrl(url);
       }
     });
  }
  getBookingUrl(url:string){      
    // 获取当前页面的协议、域名和路径
    const currentOrigin = window.location.origin;
    const currentPathname = window.location.pathname;

    // 提取原 URL 中的查询参数部分（? 及其后面的内容）
    const queryIndex = url.indexOf('?');
    const queryPart = queryIndex !== -1 ? url.substring(queryIndex) : '';

    // 拼接新的 URL：当前路径 + 查询参数
    const booking_url = `${currentOrigin}${currentPathname}${queryPart}`;

    return booking_url;
  }
  parseUrlParams(url:string) {
     if (!url.includes("?")) return {};
     const query = url.split("?")[1].split("#")[0]; // 去掉 hash
     return Object.fromEntries(new URLSearchParams(query));
  }
  dateFormatter(day?: any) {
      if (this.FlowID) {
        const queryData = this.$route.query as any;
        const today = moment().subtract(1, "days").endOf('day'); 
        const starDepartDate = moment(queryData.DepartDate).startOf('day'); // 出发开始
        const endDepartDate = queryData.DepartDateEnd ? moment(queryData.DepartDateEnd).endOf('day') : null;// 出发结束
          if (day.date < today || day.date < starDepartDate || (endDepartDate && day.date > endDepartDate)) {
            day.type = "disabled";
          }
      }
      return day;
    }
}
